import { createTheme, ThemeProvider } from "@mui/material";

export const theme = createTheme({
  direction: "rtl",
  palette: {
    primary: {
      light: "#96C6FF",
      main: "#1B569A",
      dark: "#102F58",
      contrastText: "#fff",
    },
    secondary: {
      light: "#fafafa",
      main: "#F8F8FA",
      dark: 'gray',
      contrastText: "#000000",
    },
    shadow: {
      main: "rgb(194, 194, 194)",
    },
  },
  typography: {
    fontFamily: "IRANSans",
    fontSize:16
  },
});

export const MuiThemeProivider = (props) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};
